import { CreateQuestionaireDTO } from "@/domain/dto/CreateQuestionaireDTO";
import { Questionaire } from "@/domain/entities/Questionaire";
import { IQuestionaireRepository } from "@/domain/repositories/IQuestionaireRepository";
import { ICreateQuestionaireUseCase } from "@/domain/usecases/ICreateQuestionaireUseCase";

export class CreateQuestionaireUseCase implements ICreateQuestionaireUseCase {
    repository: IQuestionaireRepository
    constructor(repository: IQuestionaireRepository) {
        this.repository = repository
    }

    execute(params: CreateQuestionaireDTO): Promise<Questionaire> {
        return this.repository.create(params)
    }
}
